import { mapState } from 'vuex'

export default {
  data() {
    return {
      bookId: ''
    }
  },
  computed: {
    ...mapState('answerRight', ['bookData']),
    bookInfo() {
      return this.bookData[this.bookId] || { bookJSON: {} }
    },
    isCanSameQuestion() {
      return this.bookInfo.bookJSON.extrapolationEnabled
    }
  },
  created() {
    this.bookId =
      this.$route.query.workbook_id || this.$route.query.workbookId || this.$route.query.booId
  },
  mounted() {},
  methods: {
    getOssBook(bookId) {
      return this.$store.dispatch('answerRight/getBookContent', {
        workbookId: bookId || this.bookId
      })
    }
  }
}
